/**
 * Wordmark — Susurro logo (mark + name).
 *
 * The name "Susurro" is drawn with the display typeface and a cool brand
 * gradient. The mark (bubble + padlock) goes on the left. Keeps the text
 * as an accessible heading.
 */

import type { JSX } from "solid-js";
import { SusurroMark } from "@/components/brand/susurro-mark";

interface WordmarkProps {
  markSize?: number;
  class?: string;
}

export function Wordmark(props: WordmarkProps): JSX.Element {
  return (
    <h1 class={`flex items-center gap-3 select-none ${props.class ?? ""}`}>
      <SusurroMark size={props.markSize ?? 48} class="drop-shadow-md" />
      <span class="relative inline-block">
        <span
          class="relative font-display text-4xl font-extrabold tracking-tight sm:text-5xl"
          style={{
            "background-image":
              "linear-gradient(95deg, oklch(0.74 0.13 278), oklch(0.68 0.14 285) 55%, oklch(0.72 0.11 210))",
            "-webkit-background-clip": "text",
            "background-clip": "text",
            color: "transparent",
            "-webkit-text-stroke": "0.5px oklch(1 0 0 / 0.15)",
          }}
        >
          Susurro
        </span>
      </span>
    </h1>
  );
}
